import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="theme"

// Controls the dark/light theme toggle button
export default class extends Controller {
  static targets = ["darkIcon", "lightIcon"]

  connect() {
    this.setInitialTheme()
  }

  toggle() {
    this.darkIconTarget.classList.toggle("hidden")
    this.lightIconTarget.classList.toggle("hidden")

    if (localStorage.getItem("color-theme") === "light") {
      document.documentElement.classList.add("dark")
      localStorage.setItem("color-theme", "dark")
    } else {
      document.documentElement.classList.remove("dark")
      localStorage.setItem("color-theme", "light")
    }
  }

  setInitialTheme() {
    const isDark =
      localStorage.getItem("color-theme") === "dark" ||
      (!("color-theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)

    document.documentElement.classList.toggle("dark", isDark)

    if (isDark) {
      this.lightIconTarget.classList.remove("hidden")
      this.darkIconTarget.classList.add("hidden")
    } else {
      this.darkIconTarget.classList.remove("hidden")
      this.lightIconTarget.classList.add("hidden")
    }
  }
}